import React, { useEffect, useRef, useState } from 'react'
import classnames from 'classnames'
import Button from '@/components/ui/button'
import ButtonIcon from '@/components/ui/ButtonIcon'
import './ActionSheetLayout.scss'
import { CloseIcon } from '@/assets/icons'
import useBodyScrollLock from "@/util/scrollLock.js";
import { i18n } from '@/locale/i18n'

const ActionSheetLayout = ({
  className,
  containerClass = '',
  title,
  action,
  content,
  onButtonClick,
  buttonDisabled,
  showCloseButton,
  onClose,
  buttonLoading,
  hasHeightOverflow,
  style,
  footer,
  headerClassList,
  closeButtonClassName,
  closeButtonPosition = 'right', // 'left' or 'right'
  actionSheetClassName = '',
  lockBodyScroll = true
}) => {
  
  const buttonClassName = className + '-button'
  const actionSheet = useRef()
  const [heightOverflow, setHeightOverflow] = useState(hasHeightOverflow)

  useBodyScrollLock(lockBodyScroll)

  useEffect(() => {
    if (hasHeightOverflow) return

    window.addEventListener('resize', verifiyHeightOverflow)
    verifiyHeightOverflow()
    return () => {
      window.removeEventListener('resize', verifiyHeightOverflow)
    }
  }, [])

  const verifiyHeightOverflow = () => {
    if (actionSheet.current) {
      // offsetHeight is enough for an overflow check and is cheaper than
      // getBoundingClientRect (no transform/sub-pixel resolution work).
      setHeightOverflow(actionSheet.current.offsetHeight > window.innerHeight * 0.9)
    }
  }

  const classList = classnames('action-sheet', className, actionSheetClassName)
  return (
    <div ref={actionSheet} className={classList} style={style}>
      {(title || showCloseButton) && (
        <header className={`action-sheet__header ${headerClassList}`}>
          <div className={closeButtonPosition === 'left' ? 'pl-8 pt-1' : ''}>
            {title}
          </div>
          {showCloseButton && (
            <div
              className={`action-sheet__close-button action-sheet__close-button--${closeButtonPosition} ${closeButtonClassName}`}>
              <ButtonIcon
                variant="normal"
                size="medium"
                iconSize={20}
                cursorPointer
                highlightOnHover
                handleOnClick={onClose}
                ariaLabel={i18n('common.close')}>
                <CloseIcon />
              </ButtonIcon>
            </div>
          )}
        </header>
      )}
      <article className={'action-sheet__container ' + containerClass}>
        {content && <div className="action-sheet__content">{content}</div>}
        {action && (
          <Button
            className={buttonClassName}
            loading={buttonLoading}
            disabled={buttonDisabled || buttonLoading}
            onClick={onButtonClick}
            type="solid"
            size="large">
            {action}
          </Button>
        )}
        {footer}
      </article>
    </div>
  )
}

export default ActionSheetLayout
